import store from "../../store/store"
import { WorkplaceKnowledgeBaseHub } from "../hubs/workplaceKnowledgeBase"

export const workplaceKnowledgeBaseHub = new WorkplaceKnowledgeBaseHub(store)
